import whatsapp from "../../assets/whatsapp.svg"

const icons =[
 {
  href:"https://wa.me/32984527181",
  url: whatsapp

 },
 {
  href:"https://www.linkedin.com/in/wellington-eduardo",
  url:"https://cdn.simpleicons.org/linkedin/#0A66C2"

 },
 {
  href:"https://github.com/WellingtonEduardo",
  url:"https://cdn.simpleicons.org/github/white"

 }

]

export default icons